import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-villageagents',
  templateUrl: './villageagents.component.html',
  styleUrls: ['./villageagents.component.scss'],
})
export class VillageagentsComponent {}
